export const cnpjMask = (value) => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3/$4-$5")
    .replace(/(-\d{2})\d+?$/, "$1");
};

export const progressiveCnpjMask = (value) => {
  const cleaned = value.replace(/\D/g, "").slice(0, 14);

  if (cleaned.length <= 2) {
    return cleaned;
  } else if (cleaned.length <= 5) {
    return cleaned.replace(/(\d{2})(\d+)/, "$1.$2");
  } else if (cleaned.length <= 8) {
    return cleaned.replace(/(\d{2})(\d{3})(\d+)/, "$1.$2.$3");
  } else if (cleaned.length <= 12) {
    return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d+)/, "$1.$2.$3/$4");
  } else {
    return cleaned.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d+)/,
      "$1.$2.$3/$4-$5"
    );
  }
};

export const cpfMask = (value) => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2");
};

/**
 * LGPD list mask: hide the middle, keep edges (full doc only on detail).
 * CPF 303.***.***-09, CNPJ 12.***.*** / ****-90. Already-masked values kept.
 */
export const maskTaxIdForList = (value) => {
  if (value == null || value === "") return "—";
  const trimmed = String(value).trim();
  if (!trimmed) return "—";
  if (trimmed.includes("*")) return trimmed;
  const digits = trimmed.replace(/\D/g, "");
  if (digits.length === 11) {
    return `${digits.slice(0, 3)}.***.***-${digits.slice(9, 11)}`;
  }
  if (digits.length === 14) {
    return `${digits.slice(0, 2)}.***.***/****-${digits.slice(12, 14)}`;
  }
  return trimmed;
};

export const receiptChargeMask =
  "99999999999-9 99999999999-9 99999999999-9 99999999999-9";

export const receiptBankMask =
  "99999.99999 99999.999999 99999.999999 9 99999999999999";

export const cepMask = (value) => {
  return value.replace(/\D/g, "").replace(/(\d{5})(\d)/, "$1-$2");
};

export const birthDateMask = (value) => {
  const digits = (value || "").replace(/\D/g, "").slice(0, 8);

  if (digits.length <= 2) {
    return digits;
  }

  if (digits.length <= 4) {
    return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  }

  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
};

export const birthDateToIso = (value) => {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value || "");
  if (!match) return "";

  return `${match[3]}-${match[2]}-${match[1]}`;
};

export const isValidBirthDate = (value) => {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value || "");
  if (!match) return false;

  const day = Number(match[1]);
  const month = Number(match[2]);
  const year = Number(match[3]);

  if (month < 1 || month > 12 || day < 1 || year < 1900) return false;

  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return false;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date < today;
};

export const isoToBirthDate = (value) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || "");
  if (!match) return "";

  return `${match[3]}/${match[2]}/${match[1]}`;
};

export const cleanTaxIDMask = (value) => {
  return value?.replace(/\./g, "")?.replace("-", "")?.replace("/", "");
};

export const phoneMask = (value) => {
  value = value.replace(/\D/g, "");
  value = value.replace(/^(\d{2})(\d)/g, "($1)$2");
  value = value.replace(/(\d{5})(\d)/, "$1-$2");
  return value;
};

export const cleanPhoneMask = (value) => {
  value = value?.replace("(", "");
  value = value?.replace(")", "");
  value = value?.replace("-", "");
  return value;
};

export const handleTaxIDInput = (value) => {
  if (value === "-") {
    return value;
  }

  let taxID = cleanTaxIDMask(value);
  if (taxID.length >= 14) {
    taxID = cnpjMask(taxID);
  } else {
    taxID = cpfMask(taxID);
  }
  return taxID;
};

export const handleBussinessTaxIDInput = (value) => {
  if (value === "-") {
    return value;
  }

  let taxID = cleanTaxIDMask(value);
  return progressiveCnpjMask(taxID);
};

export const handleTaxIDLoginInput = (value) => {
  if (value == null || value === "" || value === "-" || value.match(/^[0-9.-]+$/) == null) 
    return value;

  let taxID = cleanTaxIDMask(value);
  if(taxID.length>14) taxID=taxID.substring(0,14);
  
  if (taxID.length >= 14) {
    taxID = cnpjMask(taxID);
  } else {
    taxID = cpfMask(taxID);
  }
  return taxID;
};